// Meta Pixel + UTM tracking helpers (frontend)
import api from "./api";

const PIXEL_KEY = "flownte_pixel_id";
const UTM_KEY = "flownte_utm";
const VISIT_TRACKED = "flownte_visit_tracked";

let pixelLoaded = false;

export function loadPixel(pixelId) {
  if (!pixelId || pixelLoaded || typeof window === "undefined") return;
  pixelLoaded = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
  localStorage.setItem(PIXEL_KEY, pixelId);
}

export function getFbCookies() {
  if (typeof document === "undefined") return { fbp: null, fbc: null };
  const get = (name) => {
    const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  };
  return { fbp: get("_fbp"), fbc: get("_fbc") };
}

function newEventId() {
  return (
    Date.now().toString(36) + Math.random().toString(36).slice(2, 10)
  );
}

export function trackEvent(name, custom = {}, userData = {}) {
  if (typeof window === "undefined") return;
  const eventId = newEventId();

  // Browser pixel
  try {
    if (window.fbq) {
      window.fbq("track", name, custom, { eventID: eventId });
    }
  } catch {
    /* ignore */
  }

  // Server-side CAPI (deduped by event_id)
  const { fbp, fbc } = getFbCookies();
  api
    .post("/track/event", {
      event_name: name,
      event_id: eventId,
      user_data: { ...userData, fbp, fbc },
      custom_data: custom,
      event_source_url: window.location.href,
    })
    .catch(() => {});
}

// ---------- UTM capture ----------
export function captureUTM() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  const found = {};
  keys.forEach((k) => {
    if (params.get(k)) found[k] = params.get(k);
  });

  let stored = {};
  try {
    stored = JSON.parse(localStorage.getItem(UTM_KEY) || "{}");
  } catch {}

  if (Object.keys(found).length > 0) {
    stored = { ...stored, ...found, captured_at: new Date().toISOString() };
    localStorage.setItem(UTM_KEY, JSON.stringify(stored));
  }
  return Object.keys(stored).length ? stored : null;
}

export function getStoredUTM() {
  try {
    return JSON.parse(localStorage.getItem(UTM_KEY) || "null");
  } catch {
    return null;
  }
}

export function trackVisit() {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(VISIT_TRACKED)) return;
  const utm = captureUTM();
  if (!utm) return;
  const { fbp, fbc } = getFbCookies();
  api
    .post("/track/visit", {
      ...utm,
      referrer: document.referrer,
      landing_path: window.location.pathname,
      fbp,
      fbc,
    })
    .then(() => sessionStorage.setItem(VISIT_TRACKED, "1"))
    .catch(() => {});
}

// Bootstrap pixel from public settings
export async function bootstrapPixel() {
  try {
    const { data } = await api.get("/storefront/settings");
    if (data?.meta?.pixel_id) loadPixel(data.meta.pixel_id);
  } catch {
    /* ignore */
  }
}
